import { ProductInterface } from '../../Model/Product';
import { ObjectUtility } from '../../Service/ObjectUtility';
import { OptionsCollection } from '../Filter/OptionsCollection';

interface AnalogOutputProps {
    allProducts: ProductInterface[],
    filteredProducts: ProductInterface[],
}

export class AnalogOutputCollector {
    public static collectAvailableAnalogOutputs(
        props: AnalogOutputProps,
        fetchFromParent: boolean
    ): OptionsCollection<string> {
        const all = this.collectAnalogOutputs(props.allProducts, fetchFromParent);
        const filtered = this.collectAnalogOutputs(props.filteredProducts, fetchFromParent);

        return new OptionsCollection(all.map(value => {
            const isAvailable = filtered.contains(value.name);

            return value.withIsAvailable(isAvailable);
        }));
    }

    private static collectAnalogOutputs(
        products: ProductInterface[],
        fetchFromParent: boolean
    ): OptionsCollection<string> {
        const prefix = fetchFromParent ? '@parent.' : '';
        return OptionsCollection.fromAttributesArray([].concat(
            products.flatMap(p => ObjectUtility.valueForKeyPath(p, prefix + 'Stromausgang') || []),
            products.flatMap(p => ObjectUtility.valueForKeyPath(p, prefix + 'Spannungsausgang') || [])
        ));
    }
}
